// extracted by mini-css-extract-plugin
export var beigeBackground = "contentTiles-module--beigeBackground--71b7c";
export var heading = "contentTiles-module--heading--0a0cc";
export var item = "contentTiles-module--item--fa26b";
export var itemWrapper = "contentTiles-module--itemWrapper--26d20";
export var section = "contentTiles-module--section--02142";